(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enzo-product-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initSlideshows = (root = document) => {
      root.querySelectorAll('[data-enzo-slideshow]').forEach((media) => {
        if (media.dataset.enzoSlideshowReady === 'true') return;

        const slides = Array.from(media.querySelectorAll('.enzo-art-card__image--slide'));
        if (slides.length < 2) return;

        media.dataset.enzoSlideshowReady = 'true';
        let currentIndex = 0;
        let timerId;
        const delay = Number(media.dataset.enzoSlideshowDelay) || 2000;

        const showNext = () => {
          slides[currentIndex].classList.remove('is-active');
          currentIndex = (currentIndex + 1) % slides.length;
          slides[currentIndex].classList.add('is-active');
        };

        const start = () => {
          if (motionQuery.matches || timerId || document.hidden) return;
          timerId = window.setInterval(showNext, delay);
        };

        const stop = () => {
          if (!timerId) return;
          window.clearInterval(timerId);
          timerId = undefined;
        };

        const card = media.closest('.enzo-art-card');
        card?.addEventListener('mouseenter', stop);
        card?.addEventListener('mouseleave', start);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stop();
          else start();
        });

        start();
      });
    };

    initSlideshows();
    document.addEventListener('shopify:section:load', (event) => initSlideshows(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
